import se from "./objectWithoutPropertiesLoose3.mjs";
import P from "./extends3.mjs";
import * as u from "react";
import { clsx as Ce } from "./clsx.mjs";
import { PickersDay as ge } from "./PickersDay.mjs";
import { useNow as re, useUtils as ie, useLocaleText as Me } from "./useUtils.mjs";
import { DAY_SIZE as q, DAY_MARGIN as Q } from "./dimensions.mjs";
import { PickersSlideTransition as we } from "./PickersSlideTransition.mjs";
import { useIsDateDisabled as ve } from "./useIsDateDisabled.mjs";
import { findClosestEnabledDate as J, getWeekdays as xe } from "./date-utils.mjs";
import { getDayCalendarUtilityClass as Ne } from "./dayCalendarClasses.mjs";
import { jsxs as Z, jsx as y } from "react/jsx-runtime";
import f from "./styled.mjs";
import X from "./Typography.mjs";
import We from "./useThemeProps.mjs";
import Se from "./useTheme.mjs";
import Pe from "./useControlled.mjs";
import E from "./useEventCallback.mjs";
import Fe from "./composeClasses.mjs";
import { useSlotProps as Oe } from "./useSlotProps.mjs";
const Te = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], Le = ["ownerState"], Ae = (n) => {
  const {
    classes: o
  } = n;
  return Fe({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, Ne, o);
}, le = (q + Q * 2) * 6, _e = f("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (n, o) => o.root
})({}), Re = f("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (n, o) => o.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), Ie = f(X, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (n, o) => o.weekDayLabel
})(({
  theme: n
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (n.vars || n).palette.text.secondary
})), He = f(X, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (n, o) => o.weekNumberLabel
})(({
  theme: n
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: n.palette.text.disabled
})), je = f(X, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (n, o) => o.weekNumber
})(({
  theme: n
}) => P({}, n.typography.caption, {
  width: q,
  height: q,
  padding: 0,
  margin: `0 ${Q}px`,
  color: n.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), Ve = f("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (n, o) => o.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: le
}), Ee = f(we, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (n, o) => o.slideTransition
})({
  minHeight: le
}), Ue = f("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (n, o) => o.monthContainer
})({
  overflow: "hidden"
}), ze = f("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (n, o) => o.weekContainer
})({
  margin: `${Q}px 0`,
  display: "flex",
  justifyContent: "center"
});
function $e(n) {
  var o, x, F;
  let {
    parentProps: m,
    day: s,
    focusableDay: O,
    selectedDays: U,
    isDateDisabled: T,
    currentMonthNumber: p,
    isViewFocused: z
  } = n, $ = se(n, Te);
  const {
    disabled: L,
    disableHighlightToday: K,
    isMonthSwitchingAnimating: B,
    showDaysOutsideCurrentMonth: D,
    components: w,
    componentsProps: A,
    slots: _,
    slotProps: R,
    timezone: Y
  } = m, r = ie(), G = re(Y), I = O !== null && r.isSameDay(s, O), b = U.some((k) => r.isSameDay(k, s)), H = r.isSameDay(s, G), N = (o = (x = _?.day) != null ? x : w?.Day) != null ? o : ge, v = Oe({
    elementType: N,
    externalSlotProps: (F = R?.day) != null ? F : A?.day,
    additionalProps: P({
      disableHighlightToday: K,
      showDaysOutsideCurrentMonth: D,
      role: "gridcell",
      isAnimating: B,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": r.toJsDate(s).valueOf()
    }, $),
    ownerState: P({}, m, {
      day: s,
      selected: b
    })
  }), j = se(v, Le), c = u.useMemo(() => L || T(s), [L, T, s]), W = u.useMemo(() => r.getMonth(s) !== p, [r, s, p]), e = u.useMemo(() => {
    const k = r.startOfMonth(r.setMonth(s, p));
    return D ? r.isSameDay(s, r.startOfWeek(k)) : r.isSameDay(s, k);
  }, [p, s, D, r]), d = u.useMemo(() => {
    const k = r.endOfMonth(r.setMonth(s, p));
    return D ? r.isSameDay(s, r.endOfWeek(k)) : r.isSameDay(s, k);
  }, [p, s, D, r]);
  return /* @__PURE__ */ y(N, P({}, j, {
    day: s,
    disabled: c,
    autoFocus: z && I,
    today: H,
    outsideCurrentMonth: W,
    isFirstVisibleCell: e,
    isLastVisibleCell: d,
    selected: b,
    tabIndex: I ? 0 : -1,
    "aria-selected": b,
    "aria-current": H ? "date" : void 0
  }));
}
function ct(n) {
  const o = We({
    props: n,
    name: "MuiDayCalendar"
  }), {
    onFocusedDayChange: x,
    className: F,
    currentMonth: m,
    selectedDays: s,
    focusedDay: O,
    loading: U,
    onSelectedDaysChange: T,
    onMonthSwitchingAnimationEnd: p,
    readOnly: z,
    reduceAnimations: $,
    renderLoading: L = () => /* @__PURE__ */ y("span", {
      children: "..."
    }),
    slideDirection: K,
    TransitionProps: B,
    disablePast: D,
    disableFuture: w,
    minDate: A,
    maxDate: _,
    shouldDisableDate: R,
    shouldDisableMonth: Y,
    shouldDisableYear: r,
    dayOfWeekFormatter: G,
    hasFocus: I,
    onFocusedViewChange: b,
    gridLabelId: H,
    displayWeekNumber: N,
    fixedWeekNumber: v,
    autoFocus: j,
    timezone: c
  } = o, W = re(c), e = ie(), d = Ae(o), C = Se().direction === "rtl", ee = G || ((t, a) => e.format(a, "weekdayShort").charAt(0).toUpperCase()), g = ve({
    shouldDisableDate: R,
    shouldDisableMonth: Y,
    shouldDisableYear: r,
    minDate: A,
    maxDate: _,
    disablePast: D,
    disableFuture: w,
    timezone: c
  }), V = Me(), [te, de] = Pe({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: I,
    default: j ?? !1
  }), [M, ce] = u.useState(() => O || W), ue = E((t) => {
    z || T(t);
  }), h = (t) => {
    g(t) || (x(t), ce(t), b?.(!0), de(!0));
  }, me = E((t, a) => {
    switch (t.key) {
      case "ArrowUp":
        h(e.addDays(a, -7)), t.preventDefault();
        break;
      case "ArrowDown":
        h(e.addDays(a, 7)), t.preventDefault();
        break;
      case "ArrowLeft": {
        const i = e.addDays(a, C ? 1 : -1), l = e.addMonths(a, C ? 1 : -1), S = J({
          utils: e,
          date: i,
          minDate: C ? i : e.startOfMonth(l),
          maxDate: C ? e.endOfMonth(l) : i,
          isDateDisabled: g,
          timezone: c
        });
        h(S || i), t.preventDefault();
        break;
      }
      case "ArrowRight": {
        const i = e.addDays(a, C ? -1 : 1), l = e.addMonths(a, C ? -1 : 1), S = J({
          utils: e,
          date: i,
          minDate: C ? e.startOfMonth(l) : i,
          maxDate: C ? i : e.endOfMonth(l),
          isDateDisabled: g,
          timezone: c
        });
        h(S || i), t.preventDefault();
        break;
      }
      case "Home":
        h(e.startOfWeek(a)), t.preventDefault();
        break;
      case "End":
        h(e.endOfWeek(a)), t.preventDefault();
        break;
      case "PageUp":
        h(e.addMonths(a, 1)), t.preventDefault();
        break;
      case "PageDown":
        h(e.addMonths(a, -1)), t.preventDefault();
        break;
    }
  }), De = E((t, a) => h(a)), he = E((t, a) => {
    te && e.isSameDay(M, a) && b?.(!1);
  }), ae = e.getMonth(m), ye = u.useMemo(() => s.filter((t) => !!t).map((t) => e.startOfDay(t)), [e, s]), oe = ae, ne = u.useMemo(() => /* @__PURE__ */ u.createRef(), [oe]), fe = e.startOfWeek(W), pe = u.useMemo(() => {
    const t = e.startOfMonth(m), a = e.endOfMonth(m);
    return g(M) || e.isAfterDay(M, a) || e.isBeforeDay(M, t) ? J({
      utils: e,
      date: M,
      minDate: t,
      maxDate: a,
      disablePast: D,
      disableFuture: w,
      isDateDisabled: g,
      timezone: c
    }) : M;
  }, [m, w, D, M, g, e, c]), be = u.useMemo(() => {
    const t = e.setTimezone(m, c), a = e.getWeekArray(t);
    let i = e.addMonths(t, 1);
    for (; v && a.length < v; ) {
      const l = e.getWeekArray(i), S = e.isSameDay(a[a.length - 1][0], l[0][0]);
      l.slice(S ? 1 : 0).forEach((ke) => {
        a.length < v && a.push(ke);
      }), i = e.addMonths(i, 1);
    }
    return a;
  }, [m, v, e, c]);
  return /* @__PURE__ */ Z(_e, {
    role: "grid",
    "aria-labelledby": H,
    className: d.root,
    children: [/* @__PURE__ */ Z(Re, {
      role: "row",
      className: d.header,
      children: [N && /* @__PURE__ */ y(He, {
        variant: "caption",
        role: "columnheader",
        "aria-label": V.calendarWeekNumberHeaderLabel,
        className: d.weekNumberLabel,
        children: V.calendarWeekNumberHeaderText
      }), xe(e, W).map((t, a) => {
        var i;
        const l = e.format(t, "weekdayShort");
        return /* @__PURE__ */ y(Ie, {
          variant: "caption",
          role: "columnheader",
          "aria-label": e.format(e.addDays(fe, a), "weekday"),
          className: d.weekDayLabel,
          children: (i = ee?.(l, t)) != null ? i : l
        }, l + a.toString());
      })]
    }), U ? /* @__PURE__ */ y(Ve, {
      className: d.loadingContainer,
      children: L()
    }) : /* @__PURE__ */ y(Ee, P({
      transKey: oe,
      onExited: p,
      reduceAnimations: $,
      slideDirection: K,
      className: Ce(F, d.slideTransition)
    }, B, {
      nodeRef: ne,
      children: /* @__PURE__ */ y(Ue, {
        ref: ne,
        role: "rowgroup",
        className: d.monthContainer,
        children: be.map((t, a) => /* @__PURE__ */ Z(ze, {
          role: "row",
          className: d.weekContainer,
          "aria-rowindex": a + 1,
          children: [N && /* @__PURE__ */ y(je, {
            className: d.weekNumber,
            role: "rowheader",
            "aria-label": V.calendarWeekNumberAriaLabelText(e.getWeekNumber(t[0])),
            children: V.calendarWeekNumberText(e.getWeekNumber(t[0]))
          }), t.map((i, l) => /* @__PURE__ */ y($e, {
            parentProps: o,
            day: i,
            selectedDays: ye,
            focusableDay: pe,
            onKeyDown: me,
            onFocus: De,
            onBlur: he,
            onDaySelect: ue,
            isDateDisabled: g,
            currentMonthNumber: ae,
            isViewFocused: te,
            "aria-colindex": l + 1
          }, i.toString()))]
        }, `week-${t[0]}`))
      })
    }))]
  });
}
export {
  ct as DayCalendar
};
//# sourceMappingURL=DayCalendar.mjs.map
